<div class="card">
  @if (coins() !== undefined) {
    <profile-applet-pay-club-bg color="#FFD500"></profile-applet-pay-club-bg>

    <div class="main-container">
      <profile-applet-coin color="#FFBE00"></profile-applet-coin>

      <div class="content">
        <span class="title-wrapper">امتیاز پی‌کلاب</span>
        <span class="description">{{ coins() }} سکه</span>
      </div>

      <div class="subscription-btn">
        جوایز و تخفیف‌ها
        <div class="arrow-left"></div>
      </div>
    </div>
  } @else {
    <div class="main-container">
      <lib-ngx-skeleton-loading
        width="40px"
        height="40px"
        [classes]="'radius-rounded'"
      ></lib-ngx-skeleton-loading>

      <div class="content">
        <lib-ngx-skeleton-loading
          width="80px"
          height="44px"
          [classes]="'radius-minus'"
        ></lib-ngx-skeleton-loading>
      </div>

      <div class="subscription-btn">
        <lib-ngx-skeleton-loading
          width="80px"
          height="22px"
          [classes]="'radius-minus'"
        ></lib-ngx-skeleton-loading>
      </div>
    </div>
  }
</div>
